import script from "./TabsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=06668591&lang=css"

const __exports__ = script;

export default __exports__